import { useTranslation } from 'react-i18next';
import { SubscribeToProductOptions } from '../../../queries/ats/me/mutations';
import { Product } from '../../../queries/ats/me/products/types';
import css from './purchase-product-modal.module.scss';

interface ProductProps {
  product: Product;
  platformTitleId: string;
  purchase: (options: SubscribeToProductOptions) => void;
}

export function PurchaseProductItem({ product, platformTitleId, purchase }: ProductProps) {
  const { t } = useTranslation();

  const purchaseOptionText = product.type === 'rental' ? t('rent') : t('buy');

  return (
    <button className={css.button} onClick={() => purchase({ platformTitleId, product })}>
      {purchaseOptionText} {t('in')} {product.resolution}
      <span>{product.price},-</span>
    </button>
  );
}
